import React from 'react';
import { StarIcon, MapPinIcon } from 'lucide-react';
import { Testimonial } from '../constants/data';
interface TestimonialCardProps {
  t: Testimonial;
  showCityBadge?: boolean;
}
export function TestimonialCard({
  t,
  showCityBadge = false
}: TestimonialCardProps) {
  return <div className="glass glass-hover h-full p-6 flex flex-col text-left" data-id="element-234">
      <div className="flex items-center gap-3" data-id="element-235">
        <div className="w-11 h-11 rounded-full flex items-center justify-center font-bold text-sm" style={{
        backgroundColor: `${t.color}22`,
        color: t.color
      }} data-id="element-236">
          {t.initials}
        </div>
        <div className="flex flex-col" data-id="element-237">
          <span className="font-semibold text-white text-sm" data-id="element-238">{t.name}</span>
          <span className="text-xs text-white/50" data-id="element-239">
            {t.role} · {t.city}
          </span>
        </div>
      </div>

      <div className="mt-4 flex gap-0.5" data-id="element-240">
        {Array.from({
        length: 5
      }).map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-current" style={{
        color: '#FFD700'
      }} aria-hidden="true" data-id="element-241" />)}
      </div>

      <p className="mt-3 text-sm text-white/80 leading-relaxed flex-1" data-id="element-242">
        "{t.text}"
      </p>

      {showCityBadge && <span className="mt-4 inline-flex items-center gap-1 self-start text-xs text-white/60 glass px-2.5 py-1" data-id="element-243">
          <MapPinIcon className="w-3 h-3" style={{
        color: '#00C853'
      }} aria-hidden="true" data-id="element-244" />
          {t.city}
        </span>}
    </div>;
}